import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import {
  ExtendedTelematicsVehicle,
  MobileEnrollment,
  VehicleEnrollment,
} from '@core/store/entities/telematics/telematics.model';
import { Nullable } from '@shared/utils/type.utils';
import { TelematicsUtils } from '@shared/utils/telematics.utils';

@Component({
    selector: 'nwx-smartride-connected-car-enrollment',
    templateUrl: './smartride-connected-car-enrollment.component.html',
    styleUrls: [
        './smartride-connected-car-enrollment.component.scss',
        './../telematics/telematics.component.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SmartrideConnectedCarEnrollmentComponent implements OnInit, OnChanges {
  @Input() vehicles: ExtendedTelematicsVehicle[] = [];
  @Input() quoteState!: string;
  @Input() quoteEffectiveDate!: string;
  @Input() enrollment: Nullable<VehicleEnrollment | MobileEnrollment>;

  initialDiscount = '10%';
  maximumDiscount = '40%';

  constructor() {}

  ngOnInit(): void {
    this.updateDiscountMetadata();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.quoteState || changes.quoteEffectiveDate) {
      this.updateDiscountMetadata();
    }
  }

  private updateDiscountMetadata(): void {
    this.initialDiscount = TelematicsUtils.getDiscountMetadata(
      'initialDiscount',
      this.quoteState,
      this.quoteEffectiveDate
    );
    this.maximumDiscount = TelematicsUtils.getDiscountMetadata(
      'maximumDiscount',
      this.quoteState,
      this.quoteEffectiveDate
    );
  }

  get isCA(): boolean {
    return this.quoteState === 'CA';
  }
}
